<template>
    <div>
        <v-data-table
            :single-select="true"
            item-key="id"
            :headers="headers"
            :items="students"
            :loading="loading"
            loading-text="Loading ... please wait"
            :loader-height="6"
            hide-default-footer
            disable-pagination
        >
            <template v-slot:item.name="{ item }">
                <v-row class="align-center my-1">
                    <a :href="item.url">
                        <v-avatar size="40" color="secondary" class="my-1 mr-2">
                            <v-img
                                :src="$_.get(item, 'profile_photo_url', '')"
                                max-height="36"
                                max-width="36"
                            ></v-img>
                        </v-avatar>
                        <span>{{ item.name }}</span>
                    </a>
                </v-row>
            </template>
            <template v-slot:item.instructorName="{ item }">
                <v-row class="align-center">
                    <v-avatar size="40" color="secondary" class="my-1 mr-2">
                        <v-img
                            :src="$_.get(item, 'instructorProfileUrl', '')"
                            max-height="36"
                            max-width="36"
                        ></v-img>
                    </v-avatar>
                    <span>{{ item.instructorName }}</span>
                </v-row>
            </template>
            <template v-slot:item.programName="{ item }">
                <v-row class="align-center">
                    <v-avatar size="40" color="secondary" class="my-1 mr-2">
                        <v-img
                            :src="$_.get(item, 'programIconPath', '')"
                            max-height="36"
                            max-width="36"
                        ></v-img>
                    </v-avatar>
                    <span>{{ item.programName }}</span>
                </v-row>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    name: "program-student-list",
    components: {},
    props: {
        students: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Student",
                    align: "start",
                    sortable: false,
                    value: "name",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                    cellClass: "py-2",
                },
                {
                    text: "Email",
                    align: "start",
                    sortable: false,
                    value: "email",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Instructor",
                    align: "start",
                    sortable: false,
                    value: "instructorName",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Program",
                    align: "start",
                    sortable: false,
                    value: "programName",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Order Status",
                    align: "start",
                    sortable: false,
                    value: "orderStatus",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Order Completion",
                    align: "start",
                    sortable: false,
                    value: "orderCompletedAt",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
            ],
        };
    },

    methods: {
        // eslint-disable-next-line no-unused-vars
        filterPrograms(value, search, item) {
            return (
                search === undefined ||
                search === null ||
                item.name.toLowerCase().includes(search.toLowerCase()) ||
                item.instructors.some((ins) =>
                    ins.name.toLowerCase().includes(search.toLowerCase())
                )
            );
        },
    },
};
</script>

<style lang="scss" scoped>
</style>